var map = {
	"./Server-Busy.None.svg": 2820,
	"./Server-Busy.OfflineDrop.svg": 2821,
	"./Server-Busy.Ssh.svg": 2822,
	"./Server-Busy.TentacleActive.svg": 2823,
	"./Server-Busy.TentaclePassive.svg": 2824,
	"./Server-CalamariNeedsUpgrade.Ssh.svg": 2825,
	"./Server-CalamariNeedsUpgrade.TentacleActive.svg": 2826,
	"./Server-CalamariNeedsUpgrade.TentaclePassive.svg": 2827,
	"./Server-Default.AzureCloudService.svg": 2828,
	"./Server-Default.AzureServiceFabricCluster.svg": 2829,
	"./Server-Default.AzureSubscription.svg": 2830,
	"./Server-Default.AzureWebApp.svg": 2831,
	"./Server-Default.Kubernetes.svg": 2832,
	"./Server-Default.None.svg": 2833,
	"./Server-Default.OfflineDrop.svg": 2834,
	"./Server-Default.Ssh.svg": 2835,
	"./Server-Default.TentacleActive.svg": 2836,
	"./Server-Default.TentaclePassive.svg": 2837,
	"./Server-Disabled.AzureCloudService.svg": 2838,
	"./Server-Disabled.AzureServiceFabricCluster.svg": 2839,
	"./Server-Disabled.AzureSubscription.svg": 2840,
	"./Server-Disabled.AzureWebApp.svg": 2841,
	"./Server-Disabled.Kubernetes.svg": 2842,
	"./Server-Disabled.None.svg": 2843,
	"./Server-Disabled.OfflineDrop.svg": 2844,
	"./Server-Disabled.Ssh.svg": 2845,
	"./Server-Disabled.TentacleActive.svg": 2846,
	"./Server-Disabled.TentaclePassive.svg": 2847,
	"./Server-HasWarnings.Ssh.svg": 2848,
	"./Server-HasWarnings.TentacleActive.svg": 2849,
	"./Server-HasWarnings.TentaclePassive.svg": 2850,
	"./Server-Healthy.AzureCloudService.svg": 2851,
	"./Server-Healthy.AzureServiceFabricCluster.svg": 2852,
	"./Server-Healthy.AzureSubscription.svg": 2853,
	"./Server-Healthy.AzureWebApp.svg": 2854,
	"./Server-Healthy.Kubernetes.svg": 2855,
	"./Server-Healthy.None.svg": 2856,
	"./Server-Healthy.OfflineDrop.svg": 2857,
	"./Server-Healthy.Ssh.svg": 2858,
	"./Server-Healthy.TentacleActive.svg": 2859,
	"./Server-Healthy.TentaclePassive.svg": 2860,
	"./Server-NeedsUpgrade.TentacleActive.svg": 2861,
	"./Server-NeedsUpgrade.TentaclePassive.svg": 2862,
	"./Server-Unavailable.AzureCloudService.svg": 2863,
	"./Server-Unavailable.AzureServiceFabricCluster.svg": 2864,
	"./Server-Unavailable.AzureSubscription.svg": 2865,
	"./Server-Unavailable.AzureWebApp.svg": 2866,
	"./Server-Unavailable.Kubernetes.svg": 2867,
	"./Server-Unavailable.OfflineDrop.svg": 2868,
	"./Server-Unavailable.Ssh.svg": 2869,
	"./Server-Unavailable.TentacleActive.svg": 2870,
	"./Server-Unavailable.TentaclePassive.svg": 2871,
	"./Server-Unhealthy.AzureCloudService.svg": 2872,
	"./Server-Unhealthy.AzureServiceFabricCluster.svg": 2873,
	"./Server-Unhealthy.AzureWebApp.svg": 2874,
	"./Server-Unhealthy.Kubernetes.svg": 2875,
	"./Server-Unhealthy.OfflineDrop.svg": 2876,
	"./Server-Unhealthy.Ssh.svg": 2877,
	"./Server-Unhealthy.TentacleActive.svg": 2878,
	"./Server-Unhealthy.TentaclePassive.svg": 2879,
	"./Server-Unknown.AzureCloudService.svg": 2880,
	"./Server-Unknown.AzureServiceFabricCluster.svg": 2881,
	"./Server-Unknown.AzureSubscription.svg": 2882,
	"./Server-Unknown.AzureWebApp.svg": 2883,
	"./Server-Unknown.Kubernetes.svg": 2884,
	"./Server-Unknown.None.svg": 2885,
	"./Server-Unknown.OfflineDrop.svg": 2886,
	"./Server-Unknown.Ssh.svg": 2887,
	"./Server-Unknown.TentacleActive.svg": 2888,
	"./Server-Unknown.TentaclePassive.svg": 2889,
	"./Server-Warning.OfflineDrop.svg": 2890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2819;